export const img = (path: string) => require(`../images/${path}`)
export const instagram = (path: string) => `http://instagram.com/${path}`
